import React from "react";
import {
  Button,
  Box,
  H2,
  Modal,
  ModalContent,
  ModalFooterButtons,
  Text,
} from "@reside/ui";

export const formatRemoveAllPermissionsUserCountLabel = (
  count: number,
): string => `${count} user${count === 1 ? "" : "s"}`;

type Props = Readonly<{
  isOpen: boolean;
  selectedUserCount: number;
  isRemovingPermissions: boolean;
  onRequestClose: () => void;
  onConfirm: () => void;
}>;

export const RemoveAllPermissionsConfirmationModal = ({
  isOpen,
  selectedUserCount,
  isRemovingPermissions,
  onRequestClose,
  onConfirm,
}: Props) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={isRemovingPermissions ? undefined : onRequestClose}
    noCloseButton
  >
    {({closeModal}) => (
      <>
        <ModalContent>
          <H2>Remove all permissions</H2>
          <Box marginTop={4}>
            <Text>
              This will remove all permissions from{" "}
              <Text as="span" fontWeight="bold">
                {formatRemoveAllPermissionsUserCountLabel(selectedUserCount)}
              </Text>
              . This action cannot be undone.
            </Text>
          </Box>
        </ModalContent>
        <ModalFooterButtons>
          <Button
            outline
            color="primary"
            disabled={isRemovingPermissions}
            onClick={closeModal}
            testId="permissionsManagement-removeAllPermissionsCancel"
          >
            Cancel
          </Button>
          <Button
            color="danger"
            disabled={isRemovingPermissions}
            onClick={onConfirm}
            testId="permissionsManagement-removeAllPermissionsConfirm"
          >
            {isRemovingPermissions ? "Removing..." : "Remove all permissions"}
          </Button>
        </ModalFooterButtons>
      </>
    )}
  </Modal>
);
